import {UNAUTHED_BUSSINESS_QUERY, USER_BUSINESS_QUERY} from "./queries"
import {Business, UnauthedBusiness} from "../../types"
import client from "../../utils/clients/apollo"

class BusinessService {
  async getCurrentBusiness(): Promise<Business> {
    const res = await client.query<{myBusiness: Business}>({
      query: USER_BUSINESS_QUERY
    })

    return res.data.myBusiness
  }

  async getBusinessForRemoteId(msTeamId: string): Promise<UnauthedBusiness> {
    const res = await client.query<{businessByRemoteId: UnauthedBusiness}>({query: UNAUTHED_BUSSINESS_QUERY, variables: {id: msTeamId}})

    return res.data.businessByRemoteId
  }
}

const businessService = new BusinessService()

export default businessService
